export default __webpack_public_path__ + "static/media/cross-hydrant.d2552cf6.svg";